<template>
 <div class="thesis-online-review outline">
   <div class="wrap">
     <Layout>
       <Header>
         <div class="top-nav">
           <label class="company-label"><img height="50" width="50" src="../../assets/images/logo-white.png"/><span>研究生学位论文质量送审平台</span></label>
         </div>
       </Header>
       <Content style="flex: 1;">
         <div v-show="!showViewer" class="wrap-form">
           <section v-if="showBool" style="height:70px;line-height: 60px;"><strong class="form-label" style="font-size:24px">论文在线评阅</strong></section>
           <Form @keydown.native.enter.prevent ="searchHandle" v-if="showBool" :model="paperReviewInfoDTO" ref="thesisReviewForm">
             <FormItem>
               <Row>
                 <Col span="2" style="min-width: 60px;">
                   <strong>评阅类型：</strong>
                 </Col>
                 <Col span="18">
                   <label>{{ paperReviewInfoDTO.pylx||'隐名评阅' }}</label>
                 </Col>
               </Row>
             </FormItem>
             <FormItem>
               <Row>
                 <Col span="2"><strong>一级学科：</strong></Col>
                 <Col span="18">
                   <label>{{ firstSubjectName }}</label>
                 </Col>
               </Row>
             </FormItem>
             <FormItem>
               <Row>
                 <Col span="2"><strong>二级学科：</strong></Col>
                 <Col span="18">
                   <label>{{ secondSubjectName }}</label>
                 </Col>
               </Row>
             </FormItem>
             <FormItem>
               <Row>
                 <Col span="2"><strong>攻读类别：</strong></Col>
                 <Col span="18">
                   <label>{{ typeName }}</label>
                 </Col>
               </Row>
             </FormItem>
             <FormItem>
               <Row>
                 <Col span="2"><strong>学习方式：</strong></Col>
                 <Col span="18">
                   <label>{{ learningStyle }}</label>
                 </Col>
               </Row>
             </FormItem>
             <FormItem>
               <Row>
                 <Col span="3" style="min-width: 150px;"><strong>论文涉及的研究方向：</strong></Col>
                 <Col span="18">
                   <label>{{ paperReviewInfoDTO.researchAera }}</label>
                 </Col>
               </Row>
             </FormItem>
             <FormItem>
               <Row>
                 <Col span="2" style="min-width: 60px;"><strong>中文题目：</strong></Col>
                 <Col span="22">
                   <label>{{ paperReviewInfoDTO.titleCn }}</label>
                   <a v-if='queryData.paperInfo' @click="downloadPaper(queryData.paperInfo)">【学位论文下载】</a>
                   <a v-if='queryData.paperInfo' @click="viewPaper(queryData.paperInfo)">【学位论文在线预览】</a>
                   <a v-if='queryData.abstractInfo' @click="downloadPaper(queryData.abstractInfo)">【摘要下载】</a>
                   <a v-if='queryData.briefInfo' @click="downloadPaper(queryData.briefInfo)">【简况下载】</a>
                   <a v-if='queryData.selfInfo' @click="downloadPaper(queryData.selfInfo)">【自评表下载】</a>
                 </Col>
               </Row>
             </FormItem>

             <FormItem>
               <Row>
                 <Col span="2" style="min-width: 60px;"><strong>英文题目：</strong></Col>
                 <Col span="22">
                   <label>{{ paperReviewInfoDTO.titleEn }}</label>
                 </Col>
               </Row>
             </FormItem>
           </Form>
           <div v-if="buttonBool&&showBool" style="margin-top: 50px;">
             <Button size="large" type="primary" @click="accept">接  收</Button>
             <Button size="large" type="primary" style="margin-left: 20px;" @click="delay">退  回</Button>
           </div>
           <Modal
               v-model="comfirmModal"
               title="信息提示"
               @on-ok="confirmOk">
             <p>确定要退回论文吗</p>
           </Modal>
           <Modal
               v-model="outModal"
               :title="titleValue"
               :width= 'widthS'
               :loading="loading"
           >
             <Form @keydown.native.enter.prevent ="searchHandle" v-if="codeFormBool" :model="loginByPhone"  label-position="left" :label-width="10">
               <FormItem style="width:350px" label="" prop="phone">
                 <label>手机号：</label>
                 <Input :disabled="codeBool" style="width:250px;display:inline-block"  v-model="loginByPhone.phone" placeholder="请输入手机号"></Input>
               </FormItem>
               <div v-if="codeBool">
                 <FormItem  style="width:350px" label="" prop="code">
                   <label style="position:relative!important;top:-9px!important">验证码：</label>
                   <!--<label v-else>验证码：</label>-->
                   <div style="display:inline-block;">
                     <Input style="width:250px;" v-model="loginByPhone.code" placeholder="输入验证码" class="send-message">
                       <span style="float:right;cursor:pointer" slot="append" :class="{'disabled': (!formItemRules.isPHONE.test(loginByPhone.phone)||loginByPhone.sending)}" @click="getMessageCode">{{loginByPhone.sending?loginByPhone.countDown+'秒':'发送'}}</span>
                     </Input>
                   </div>
                 </FormItem>
               </div>
             </Form>
             <Alert v-if="expInfoModal" show-icon banner>收集个人信息仅为支付评阅费用、报税使用，不会将信息泄露给第三方，请您务必填写并核实无误！</Alert>
             <expert-info v-if="expInfoModal"
                          :parentItems="formItems"
                          :parentPhone='loginByPhone.phone'
                          ref="child"
             >
             </expert-info>
             <div slot="footer">
               <!-- <Button type="text" size="large" @click="cancel">取消</Button> -->
               <Button v-if="codeFormBool&&!codeBool" type="primary" size="large" @click="ok">下一步</Button>
               <Button v-else-if="expInfoModal" type="primary" size="large" @click="okInfo">下一步</Button>
               <Button v-else-if="codeBool&&!saveBool" type="primary" size="large" @click="postLogin">下一步</Button>
               <Button v-else-if="saveBool" type="primary" size="large" @click="saveThesisInfo">下一步</Button>
             </div>
           </Modal>
         </div>
         <div v-show="showViewer" class="close-panel" @click="showViewer=false">
           <Icon type="ios-close-circle"/>
         </div>
         <viewer v-show="showViewer" v-if="viewerSrc" :url="viewerSrc"></viewer>
       </Content>
       <Footer>
         <p class="register">
           建议您使用Google Chrome、IE11以上版本或360浏览器极速模式以达到最佳展示效果
         </p>
       </Footer>
     </Layout>
   </div>
  </div>
</template>

<script>
// import ThesisOnlineReview from '../customPage/expertManage/thesisOnlineReview'
import expertInfo from '../customPage/expertManage/expertInfo'
import viewer from '../customPage/thesisManage/viewer'
/* global FormItemRules:true */
export default {
  components: {expertInfo, viewer},
  data () {
    return {
      // id: '',
      // acceptNum: '',
      showViewer: false,
      viewerSrc: '',
      outModal: false,
      expInfoModal: false, // false
      loading: true,
      codeBool: false,
      codeFormBool: true,
      saveBool: false,
      buttonBool: true,
      comfirmModal: false,
      showBool: false,
      timeBool: false,
      disablePhone: true,
      autoAccept: false,
      titleValue: '身份验证',
      // widthM: '800',
      widthS: '350',
      firstSubjectName: '',
      secondSubjectName: '',
      typeName: '',
      learningStyle: '',
      loginByPhone: {
        phone: '',
        code: '',
        sending: false,
        countDown: 60
      },
      expertInfo: {},
      queryData: {},
      paperReviewInfoDTO: {},
      formItemRules: {},
      formItems: [
        {
          label: '姓名',
          name: 'name',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '姓名不能为空', trigger: 'blur'}]
        },
        {
          label: '证件类型',
          name: 'idCardType',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '证件类型不能为空', trigger: 'change'}]
        },
        {
          label: '证件号码',
          name: 'idCard',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '证件号码不能为空', trigger: 'blur'}]
        },
        {
          label: '电子信箱',
          name: 'email1',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '电子信箱不可为空', trigger: 'blur'}]
        },
        {
          label: '移动电话',
          name: 'phone',
          readonly: true,
          component: 'input',
          rules: [{required: true, message: '移动电话不可为空', trigger: 'blur'}]
        },
        {
          label: '一级学科',
          name: 'mFirstSubjectCode',
          labelname: 'mFirstSubjectName',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '一级学科不可为空', trigger: 'blur'}]
        // rules: [{required: true, trigger: 'blur'}]
        },
        {
          label: '二级学科',
          name: 'mSecondSubjectCode',
          labelname: 'mSecondSubjectName',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '二级学科不可为空', trigger: 'blur'}]
        // rules: [{required: true, trigger: 'blur'}]
        },
        {
          label: '研究方向',
          name: 'researchAreaOne',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '研究方向不可为空', trigger: 'blur'}]
        },
        {
          label: '导师类别',
          name: 'acTutorType',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '导师类别不能为空', trigger: 'change'}]
        },
        {
          label: '指导学生类别',
          name: 'studentType',
          readonly: false,
          component: 'select',
          options: [{
            label: '专业学位',
            value: '专业学位'
          },
          {
            value: '学术学位',
            label: '学术学位'
          }],
          rules: [{required: true, message: '指导学生类别', trigger: 'change'}]
        },
        {
          label: '职称',
          name: 'techPosition',
          readonly: false,
          component: 'select',
          options: [
            {
              value: '07',
              label: '教授'
            },
            {
              value: '06',
              label: '副教授'
            },
            {
              value: '05',
              label: '讲师(博士学位)'
            },
            {
              value: '04',
              label: '正高级'
            },
            {
              value: '03',
              label: '副高级'
            },
            {
              value: '02',
              label: '中级'
            },
            {
              value: '01',
              label: '初级'
            },
            {
              value: '00',
              label: '无'
            }
          ],
          rules: [{required: true, message: '职称不能为空', trigger: 'blur'}]
        },
        {
          label: '单位代码',
          name: 'orgCode',
          readonly: false,
          component: 'input'
          // rules: [{required: true, message: '单位代码不能为空', trigger: 'blur'}]
        },
        {
          label: '工作单位',
          name: 'orgName',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '单位名称不能为空', trigger: 'blur'}]
        },
        {
          label: '银行卡开户省份',
          name: 'bankProvince',
          labelname: 'bankProvince',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '银行卡开户省份不可为空', trigger: 'change'}]
          // rules: [{required: true, trigger: 'blur'}]
        },
        {
          label: '开户银行',
          name: 'bankName',
          labelname: 'bankName',
          readonly: false,
          component: 'select',
          options: [],
          rules: [{required: true, message: '开户银行不可为空', trigger: 'change'}]
        },
        {
          label: '银行卡号',
          name: 'bankCardCode',
          readonly: false,
          component: 'input',
          rules: [{required: true, message: '卡号不可为空', trigger: 'blur'}]
        }
      ]
    }
  },
  created () {
    const _self = this;
    _self.formItemRules = FormItemRules
    this.autoAccept = false
    this.code = this.$route.query['reviewCode']
    this.getQueryByCode(this.code)
    // this.fetchProList()
    // this.fetchBankList()
  },
  mounted () {
  },
  watch: {
    expInfoModal (value) {
      if (value) {
        this.titleValue = '请填写个人信息'
      } else {
        this.titleValue = '身份验证'
      }
    }
  },
  methods: {
    ok () {
      this.sendMessage()
      this.expertInfo.phone = this.loginByPhone.phone
    },
    okInfo () {
      this.$refs.child.validate().then(res => {
        if (res) {
          this.expertInfo = this.$refs['child'].expertInfo
          if (this.expertInfo) {
            this.loginByPhone.phone = this.expertInfo.phone
            if (!this.formItemRules.isPHONE.test(this.loginByPhone.phone)) {
              this.$Message.warning('请输入有效的电话号码');
            } else {
              this.widthS = '350'
              this.codeFormBool = true
              this.codeBool = true
              this.expInfoModal = false
              this.saveBool = true
              this.getMessageCode()
            }
          }
        }
      })
    },
    confirmOk () {
      let url = '/expReviewCodeLogin/refusePaper/'
      this.fetch(url + this.code).then(res => {
        if (res) {
          this.$Message.success('论文已退回');
          window.close();
        } else {
          this.$Message.success('错误');
        }
      })
    },
    cancel () {
      this.outModal = false
    },
    accept () {
      this.autoAccept = true
      this.widthS = '350'
      this.outModal = true
      this.expInfoModal = false
      this.loading = true
      this.codeBool = false
      this.codeFormBool = true
    },
    showPhone () {
      this.widthS = '350'
      this.outModal = true
      this.expInfoModal = false
      this.loading = true
      this.codeBool = false
      this.codeFormBool = true
    },
    delay () {
      this.comfirmModal = true
    },
    checkPhone () {
      let url = '/expReviewCodeLogin/verifyMobile/'
      this.fetch(url, {mobile: this.loginByPhone.phone, reviewCode: this.code}).then(res => {
        if (res.data === 1) {
          // 手机号存在
          // this.loading = false
          // this.expInfoModal = true
          this.codeBool = true
          this.$Message.success('操作成功');
          const _self = this;
          if (!_self.loginByPhone.sending) {
            _self.loginByPhone.sending = true;
            _self.loginByPhone.countDown = 60;

            _self.timer = setInterval(function () {
              _self.loginByPhone.countDown = --_self.loginByPhone.countDown;
              if (_self.loginByPhone.countDown <= 0) {
                clearInterval(_self.timer);
                _self.loginByPhone.sending = false;
              }
            }, 1000)
          } else {
            _self.$Message.info(`短信已发送，请输入验证码，或再${_self.loginByPhone.countDown}秒后重试`);
          }
        } else {
          this.widthS = '900'
          this.codeFormBool = false
          this.expInfoModal = true
          this.$Message.success('请填写专家信息');
        }
      })
    },
    getMessageCode () {
      const _self = this;
      if (!_self.formItemRules.isPHONE.test(_self.loginByPhone.phone)) {
        _self.$Message.warning('请输入有效的电话号码');
      } else if (!_self.loginByPhone.sending) {
        _self.loginByPhone.sending = true;
        this.timeBool = true
        _self.loginByPhone.countDown = 60;

        _self.timer = setInterval(function () {
          _self.loginByPhone.countDown = --_self.loginByPhone.countDown;
          if (_self.loginByPhone.countDown <= 0) {
            clearInterval(_self.timer);
            _self.loginByPhone.sending = false;
            this.timeBool = false
          }
        }, 1000);

        _self.fetch('/expReviewCodeLogin/sendVerificationCode', {phone: _self.loginByPhone.phone}).then(res => {
          _self.$Message.success('发送成功');
        }).catch(error => {
          console.log(error);
          // _self.$Message.error('验证码发送失败，请重新操作');
          // 发送短信请求失败，则初始化让用户重新发送
          if (_self.timer) {
            clearInterval(_self.timer);
          }
          _self.loginByPhone.sending = false;
          this.timeBool = false
        });
      } else {
        _self.$Message.info(`短信已发送，请输入验证码，或再${_self.loginByPhone.countDown}秒后重试`);
      }
    },
    postLogin () {
      const _self = this;
      _self.post('/sys/SMSLogin', {
        mobile: _self.loginByPhone.phone,
        smsCode: _self.loginByPhone.code
      }).then(res => {
        sessionStorage.setItem('token', res.data.token);
        sessionStorage.setItem('name', res.data.user.name);
        sessionStorage.setItem('schoolName', res.data.user.schoolName);
        _self.$store.commit('sessionInit');

        _self.fetch('/sys/role/chooseExpertRole').then(res => {
          _self.getRole(res.data);
          let id = this.$route.query['reviewCode']
          _self.post('/exp/expReviewInfo/receivePaperByReviewCode', { id: id }).then(res => {
          })
        });
      });
    },
    getRole (defaultRoleMsg) {
      const _self = this;
      _self.roleList = []
      _self.roleLoaded = false
      _self.fetch('/sys/role/queryExistRoleListByUserId').then(res => {
        _self.roleLoaded = true
        if (res.data) {
          _self.roleList = res.data
          sessionStorage.setItem('roleList', JSON.stringify(_self.roleList));
          _self.$store.commit('roleListInit');
          if (defaultRoleMsg && defaultRoleMsg.role) {
            sessionStorage.setItem('menu', JSON.stringify(defaultRoleMsg.list));
            sessionStorage.setItem('role', JSON.stringify(defaultRoleMsg.role));
            // sessionStorage.setItem('balances', res.data.user.balances || '');
            _self.$store.commit('roleInit')
            // 跳转至专家页
            _self.$router.push({path: '/shell/custom/expertManage/thesisOnlineReview', query: {id: this.code, auto: '1'}});
          } else {
            _self.curPage = 'chooseRole';
            if (_self.roleList.length === 1) {
              _self.getRoleMenu(res.data[0].roleId, res.data[0].roleName)
            }
          }
        }
      })
    },
    getRoleMenu (id, name) {
      const _self = this;
      _self.fetch('/sys/role/chooseRole', {roleId: id}).then(res => {
        sessionStorage.setItem('menu', JSON.stringify(res.data.list));
        sessionStorage.setItem('role', JSON.stringify(res.data.role));
        _self.$store.commit('roleInit')
        if (_self.$route.query.redirect) {
          _self.$router.push({path: _self.$route.query.redirect});
        } else {
          _self.$router.push({path: '/'});
        }
      });
    },
    sendMessage () {
      const _self = this;
      if (!_self.formItemRules.isPHONE.test(_self.loginByPhone.phone)) {
        _self.$Message.warning('请输入有效的电话号码');
      } else {
        this.checkPhone()
      }
    },
    saveThesisInfo () {
      if (this.expertInfo.studentType) {
        let tutorType = this.expertInfo.acTutorType
        delete this.expertInfo.proTutorType
        delete this.expertInfo.acTutorType
        if (this.expertInfo.studentType === '专业学位') {
          this.expertInfo.proTutorType = tutorType
        }
        if (this.expertInfo.studentType === '学术学位') {
          this.expertInfo.acTutorType = tutorType
        }
      }
      let params = {
        expInfoEntity: {...this.expertInfo},
        verificationCode: this.loginByPhone.code
      }
      this.post('/expReviewCodeLogin/saveExpInfo', params).then(res => {
        if (res.code === 200) {
          this.postLogin()
        }
      })
    },
    downloadPaper (arg) {
      // 根据id下载论文
      this.fetch('/expReviewCodeLogin/downloadFile/' + arg.id).then(res => {
        let url = res.data
        setTimeout(() => {
          window.open(url)
        }, 500);
      });
    },
    viewPaper (arg) {
      // 根据id下载论文
      this.fetch('/expReviewCodeLogin/downloadFile/' + arg.id).then(res => {
        this.viewerSrc = res.data
        this.showViewer = true;
      });
    },
    queryThesisInfo () {
      // 根据id查询论文信息
      this.fetch('/expReviewCodeLogin/queryReviewInfoByExp/' + this.$route.query['reviewCode']).then(res => {
        if (res.code === 200) {
          this.queryData = res.data
          this.paperReviewInfoDTO = res.data.paperBaseInfo
          this.firstSubjectName = res.data.paperBaseInfo.firstSubjectName
          this.secondSubjectName = res.data.paperBaseInfo.secondSubjectName
          this.typeName = res.data.paperBaseInfo.typeName
          this.learningStyle = res.data.paperBaseInfo.learningStyle
        }
      })
    },
    getQueryByCode (code) {
      this.fetch('/expReviewCodeLogin/queryReviewInfoByExp/' + code).then(res => {
        if (res.code === 200) {
          if (res.data.expReview.expId) {
            this.expId = res.data.expReview.expId
            this.disablePhone = true
            this.id = res.data.expReview.id
            this.degreeType = res.data.paperBaseInfo.degreeType
            this.unitCode = res.data.paperBaseInfo.unitCode
            this.showPhone()
          } else {
            this.disablePhone = true
            this.showBool = true
            this.id = res.data.expReview.id
            this.degreeType = res.data.paperBaseInfo.degreeType
            this.unitCode = res.data.unitCode
            this.queryThesisInfo()
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
<style lang="less" scoped>
  .thesis-online-review{
    width: 100%;
    .top-nav {
      .company-label {
        color: @normal-color;
        font-size: @font-size-large;
        img {
          display: inline-block;
          float: left;
          margin: 5px 10px 5px 0;
        }
        span {
          display: inline-block;
        }
      }
    }
    .close-panel {
      position: absolute;
      font-size: 30px;
      color: rgba(0, 0, 0, .6);
      right: 15px;
      height: 30px;
      line-height: 30px;
      top: 60px;
      .kh-icon {
        cursor: pointer;
      }
    }
    .wrap-form{
      background-color: #ffffff;
      border-radius: 4px;
      margin: 20px auto;
      padding: 20px;
      position: relative;
      width: 1000px;
    }
    .register {
      color: @text-color;
      text-align: center;
      line-height: 30px;
      margin: 0 auto;
      font-size: 12px;
      opacity: 0.8;
    }
  }
</style>
<style lang="less">
  .thesis-online-review.outline {
    .kh-form-item-content {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/paperReview/index.vue